import React from "react";
import styles from "./TestimonialSection.module.css";
import { FaQuoteLeft } from "react-icons/fa";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

const TestimonialSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <FaQuoteLeft className={styles.quoteIcon} />
        <blockquote className={styles.quote}>
          "Attending the Shravani Mela was a life-changing experience for me.
          Walking barefoot with thousands of fellow devotees, chanting ‘Bol
          Bam’, and feeling the energy of the crowd was unlike anything I’ve
          ever witnessed.Deoghar truly comes alive during this month-long
          pilgrimage." — Rohit Mishra, Pilgrim from Varanasi
        </blockquote>
      </div>
      <div className={styles.imageWrapper}>
        <img
          src="images/Pilgrimage/DeogharTemple3.jpg"
          alt="Preview not available"
          className={styles.hikerImage}
        />
      </div>
    </section>
  );
};

export default TestimonialSection;
